import { render, staticRenderFns } from "./CustomerLogoUploader.vue?vue&type=template&id=5edf2182&scoped=true"
import script from "./CustomerLogoUploader.vue?vue&type=script&lang=js"
export * from "./CustomerLogoUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edf2182",
  null
  
)

export default component.exports